import { FinalVisualizationBuilder } from '../../../app/configurator/VisualizationBuilder';
import { MoneyData, ProductConfigurationOrigin } from '../../../app/data/model';
import ConfigurationImage from '../../../app/shared/components/ConfigurationImage';
import { CartItemDetails } from '../../cart/CartItem/CartItemDetails/CartItemDetails';
import { ShoppingCartItemBasicInfoTranslation } from '../../localization/SiteTranslation';
import css from './ShoppingCartItemBasicInfo.css';

interface Props {
  item: {
    code: string;
    configurationCodeOrigin: ProductConfigurationOrigin;
    quantity: number;
    listPrice: MoneyData;
    salePrice: MoneyData;
  };
  translation: ShoppingCartItemBasicInfoTranslation;
}

export const ShoppingCartItemBasicInfo = ({ item, translation }: Props) => (
  <div className={css.container}>
    <ConfigurationImage
      configurationCodeOrigin={item.configurationCodeOrigin}
      imageFallbackClassName={css.imageFallback}
      className={css.image}
      src={FinalVisualizationBuilder.buildUrl(item.code, undefined, undefined, 140, 140)}
      width={140}
      height={140}
      sharpeningFactor={1.5}
      scalingMode="fit"
    />
    <div className={css.detailsContainer}>
      <CartItemDetails
        className={css.details}
        code={item.code}
        quantity={item.quantity}
        // Do not show 0 prices
        listPrice={item.listPrice.amount ? item.listPrice : undefined}
        salePrice={item.salePrice.amount ? item.salePrice : undefined}
        translation={translation.cartItemDetails}
      />
    </div>
  </div>
);
